import { render, staticRenderFns } from "./QoosquarePeople.vue?vue&type=template&id=de59f056&scoped=true&"
import script from "./QoosquarePeople.vue?vue&type=script&lang=js&"
export * from "./QoosquarePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de59f056",
  null
  
)

export default component.exports